export enum UserRole {
    Unknown = 'Unknown',
    Retailer = 'Retailer',
    Admin = 'Admin',
    SupportStaff = 'Support Staff',
}
